import moment from "moment-timezone";
import {StorageKeys} from "../constants/StorageKeys";

class TimezoneStore {
    marketTimezones = ['GMT', 'Asia/Taipei', 'Asia/Seoul'];
    selectableTimezones = [];
    applicationTimezone = null;

    constructor() {
        const localTimezone = moment().tz(moment.tz.guess());
        this.applicationTimezone = localStorage.getItem(StorageKeys.TIMEZONE_STORAGE_KEY) || localTimezone.tz();

        this.marketTimezones.forEach(zone => {
            this.selectableTimezones.push({timezone: moment().tz(zone), isLocal: zone === localTimezone.tz()});
        });
        this.insertTimezone(localTimezone);

        const selectedTimezone = moment().tz(this.applicationTimezone) || localTimezone;
        this.insertTimezone(selectedTimezone);

        moment.tz.setDefault(this.applicationTimezone);
    }

    getSelectableTimezones() {
        return this.selectableTimezones;
    }

    getApplicationTimezone() {
        return this.applicationTimezone;
    }

    setApplicationTimezone(timezone) {
        localStorage.setItem(StorageKeys.TIMEZONE_STORAGE_KEY, timezone);
        moment.tz.setDefault(timezone);
        this.applicationTimezone = timezone;
    }

    insertTimezone(timezoneToAdd) {
        let index = this.selectableTimezones.findIndex(currentTimezone =>  currentTimezone.timezone.tz() === timezoneToAdd.tz());

        if (index === -1) {
            this.selectableTimezones.push({timezone: timezoneToAdd, isLocal: timezoneToAdd.tz() === moment().tz(moment.tz.guess()).tz()});
        }
    }
}

export const timezoneStore = new TimezoneStore();
